
import { Component, Vue } from 'vue-property-decorator'

import BacLiabilityDisclaimer from '@/components/BacLiabilityDisclaimer.vue'

@Component({
  components: {
    BacLiabilityDisclaimer
  }
})
export default class LiabilityDisclaimer extends Vue {}
